module.exports = __webpack_public_path__ + "static/media/icon-exclamation-mark.2a0bed0a.svg";